import { render, staticRenderFns } from "./CustomFieldActionButtonsComponent.vue?vue&type=template&id=60aba5fa&scoped=true&lang=pug"
import script from "./CustomFieldActionButtonsComponent.vue?vue&type=script&lang=ts"
export * from "./CustomFieldActionButtonsComponent.vue?vue&type=script&lang=ts"
import style0 from "./CustomFieldActionButtonsComponent.vue?vue&type=style&index=0&id=60aba5fa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aba5fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60aba5fa')) {
      api.createRecord('60aba5fa', component.options)
    } else {
      api.reload('60aba5fa', component.options)
    }
    module.hot.accept("./CustomFieldActionButtonsComponent.vue?vue&type=template&id=60aba5fa&scoped=true&lang=pug", function () {
      api.rerender('60aba5fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customFields/customFieldsPlayground/CustomFieldActionButtons/CustomFieldActionButtonsComponent.vue"
export default component.exports